<template>
	<main class="Page404 viewCenter">
		<div class="c_inner">
			<h1>404</h1>
			<img src="@/assets/img/common/icon_404.svg" alt="404" class="icon_404" loading="lazy" />
			<div class="text_box">
				<h2>404 ERROR</h2>
				<p>존재하지 않는 주소를 입력하셨거나, 요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.</p>
			</div>
			<button type="button" class="c_button primary-fill" @click="handleMoveHome">홈으로</button>
		</div>
	</main>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

const handleMoveHome = () => {
	router.replace('/');
};
</script>

<style scoped>
/* 404 START */
.Page404 {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	text-align: center;
	font-weight: var(--font-w-semi-bold);
	width: 100%;
	min-height: 100vh;
}
.Page404 .c_inner {
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: var(--space-xx-large);
}
.Page404 .icon_404 {
	width: 50%;
	max-width: 16rem;
}
.Page404 h1 {
	display: none;
	font-size: var(--font-s-xx-large);
	margin-bottom: 2rem;
}
.Page404 .text_box {
	display: flex;
	flex-direction: column;
	gap: var(--space-mid);
	color: var(--color-font-white);
}
.Page404 .text_box h2 {
	color: var(--color-font-white);
	font-size: var(--font-s-xx-large);
}
.Page404 .text_box p {
	font-size: var(--font-s-large);
	font-weight: var(--font-w-regular);
	color: var(--color-font-white);
	line-height: 1.4;
	letter-spacing: -1px;
	word-break: keep-all;
}
.Page404 button {
	max-width: 40rem;
	height: 4.8rem;
	width: 100%;
}
.Page404 svg {
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: auto;
	margin-bottom: -1rem;
}
@media screen and (min-width: 768px) {
}
.viewCenter {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: calc(100vh - var(--header-height) - var(--footer-height));
}
</style>
